// Angular
import { ChangeDetectorRef, Component, Inject, OnInit, ViewRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { KDDatHangService } from '../kd-dat-hang-service/kd-dat-hang.service';

@Component({
	selector: "kt-forecast-update-modal",
	templateUrl: "./forecast-update-modal.component.html",
	styleUrls: ["./forecast-update-modal.component.scss"],
})
export class ForecastUpdateModelComponent implements OnInit {
	CONFIG: CommonConFig;

	list: any[] = [];
	select: string = "";
	filtered: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	FilterCtrl: string = "";
	haveElement: boolean = false;
	
	list2: any[] = [];
	select2: string = "";
	filtered2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	FilterCtrl2: string = "";
	haveElement2: boolean = false;

	viewLoading: boolean = false;
	form: FormGroup;
	content: string = "";
	forecastId: number = null;
	id: number = 0;
	code: string = "";
	name: string = "";
	element: any = { id: null, code: "", name: "", type: "",  typeId: null};
	target: string = "";

	constructor(public dialogRef: MatDialogRef<ForecastUpdateModelComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private changeDetect: ChangeDetectorRef, private layoutUtilsService: LayoutUtilsService, private forecastService: KDDatHangService) {}

	ngOnInit() {
		this.CONFIG = new CommonConFig();
		const { content, list, forecastId, id, code, name, element, target, list2 } = this.data;
		this.content = content;
		this.forecastId = forecastId;
		this.id = id;
		this.code = code;
		this.name = name;
		this.element = element;
		this.target = target;
		this.list = list || [];
		this.list2 = list2 || [];
		this.filtered.next(this.list.slice());
		this.filtered2.next(this.list2.slice());
		this.initForm();
		this.changeDetectView();
	}

	initForm() {
		this.form = this.formBuilder.group({
			OLDCODE: [{ value: this.element.code, disabled: true }],
			OLDNAME: [{ value: this.element.name, disabled: true }],
			NEWCODE: [""],
			NEWNAME: [{ value: "", disabled: true }],
			OLDTYPE: [{ value: this.element.type, disabled: true }],
			NEWTYPE: [""],
		});
		
		if (this.element.id) {
			this.form.controls["NEWCODE"].disable();
		}
		if (this.element.typeId) {
			this.form.controls["NEWTYPE"].disable();
		}

		this.form.controls["OLDCODE"].disable();
		this.form.controls["OLDNAME"].disable();
		this.form.controls["NEWNAME"].disable();
		this.form.controls["OLDTYPE"].disable();
	}

	filter() {
		if (!this.list) {
			return;
		}

		let search = this.FilterCtrl;
		if (!search) {
			this.filtered.next(this.list.slice());
			return;
		}
		search = search.toLowerCase();
		this.filtered.next(this.list.filter((ts) => ts[this.code].toLowerCase().indexOf(search) > -1 || ts[this.name].toLowerCase().indexOf(search) > -1));
	}
	
	filter2() {
		if (!this.list2) {
			return;
		}

		let search = this.FilterCtrl2;
		if (!search) {
			this.filtered2.next(this.list2.slice());
			return;
		}
		search = search.toLowerCase();
		this.filtered2.next(this.list2.filter((ts) => ts.TenLoaiKH.toLowerCase().indexOf(search) > -1));
	}

	displayName() {
		if (!this.form) return "";
		const form = this.form.controls["NEWCODE"];
		const selected = form.value && form.value > 0 && this.list.length > 0;

		return selected ? this.list.find((x) => x[this.id] == +form.value)[this.code] : "";
	}
	
	displayName2() {
		if (!this.form) return "";
		const form = this.form.controls["NEWTYPE"];
		const selected = form.value && form.value > 0 && this.list2.length > 0;

		return selected ? this.list2.find((x) => x.Id_LoaiKH == +form.value).TenLoaiKH: "";
	}

	selected(value) {
		if (!value) return;

		let index = this.list.findIndex((x) => x[this.id] == Number(value));
		if (index > -1) {
			this.form.controls["NEWCODE"].setValue(value.toString());
			this.form.controls["NEWNAME"].setValue(this.list[index][this.name]);
			this.element.code = this.list[index][this.code];
			this.element.name = this.list[index][this.name];
		}

		this.changeDetect.detectChanges();
	}
	
	selected2(value) {
		if (!value) return;

		let index = this.list2.findIndex((x) => x.Id_LoaiKH == Number(value));
		if (index > -1) {
			this.form.controls["NEWTYPE"].setValue(value.toString());
		}

		this.changeDetect.detectChanges();
	}

	quit(): void {
		this.dialogRef.close();
	}

	save(): void {
		const selected = this.form.controls["NEWCODE"].value;
		const selectedType = this.form.controls["NEWTYPE"].value;
		if ((!selected && !this.element.id) || (!selectedType && !this.element.typeId && this.list2.length )) {
		    this.layoutUtilsService.showErorr(`Vui lòng thay đổi ít nhất một thông tin mới trước khi lưu!`);
		    return;
        }
        
		const dialogConfirm = this.layoutUtilsService.POP02_DanhMuc();
		dialogConfirm.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			var update1 = selected ? Number(selected) : null;
			var update2 = selectedType ? Number(selectedType) : null
			this.forecastService.updateForecastTarget(update1, this.target, this.forecastId, update2)
			    .subscribe((res) => {
    				if (res && res.status == 1) {
    					this.layoutUtilsService.showInfo("Cập nhật thành công");
    					this.dialogRef.close({ id: update1 || this.element.id, code: this.element.code, name: this.element.name,  typeId: update2 || this.element.typeId});
    				} else {
    					this.layoutUtilsService.showErorr(res.error.message || "Lỗi dữ liệu");
    				}
			});
		});
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
}
